import {Action, Middleware} from '@reduxjs/toolkit';

import {authSlice, AuthSliceActions} from './authSlice';
import {tokenSlice, TokenSliceActions} from './tokenSlice';
import {userManager} from './userManager';

/*
 IMPORTANT: This middleware is used to sync the user state with the global store, 
 please update the logic if the user state changes.
*/

export const userMiddleware: Middleware = () => next => (action: Action) => {
  const result = next(action);
  const authActions: AuthSliceActions = authSlice.actions;
  const tokenDataActions: TokenSliceActions = tokenSlice.actions;

  if (action.type === authActions.setProfile.type) {
    userManager.updateUser();
  }

  if (action.type === authActions.unSetUser.type) {
    userManager.clearToken();
  }

  if (action.type === tokenDataActions.setTokenData.type) {
    userManager.updateToken();
  }

  return result;
};
